import { API, graphqlOperation } from "aws-amplify";
import { Dictionnary } from "../API";
import { listDictionnarys } from "../graphql/queries";
import { IConnectListQuery } from "../types";

export type DictionnarySelectItem = { display: string; value: string }
export type DictionnaryContext = {
  customerId: string;
};

let dictionnary: Dictionnary[];
let loadingPromise: Promise<any>;
const loadDictionnary = async (context: DictionnaryContext) => {
  let _dictionnary: Dictionnary[] = [];
  if (loadingPromise) {
    return loadingPromise;
  }
  loadingPromise = new Promise(async (resolve) => {
    let nextToken = null;
    do {
      const batch = await API.graphql(graphqlOperation(listDictionnarys, {
        filter: {
          or: [{
            customerId: { eq: context.customerId }
          }, {
            customerId: { eq: 0 }
          },]
        },
        nextToken,
        limit: 20,
      })) as IConnectListQuery<
        Dictionnary,
        'listDictionnarys'
      >;;
      _dictionnary = [..._dictionnary, ...batch.data['listDictionnarys']?.items];
      nextToken = batch.data['listDictionnarys']?.nextToken;
    } while (nextToken)
    dictionnary = _dictionnary;
    resolve(_dictionnary);
  });
  await loadingPromise;
  return _dictionnary;
};

const getDictionnaryByType = async (type: string, context: DictionnaryContext): Promise<Array<DictionnarySelectItem>> => {
  if (!dictionnary) {
    await loadDictionnary(context);
  }
  const list = [];
  for (const i in dictionnary) {
    const item = dictionnary[i];
    if (item.type === type) {
      list.push({
        display: item.value as string,
        value: item.value as string
      })
    }
  }
  return list;
}

export const getAssignedByList = (context: DictionnaryContext) => {
  return getDictionnaryByType('ASSIGNED_BY', context)
}

export const getTeamList = (context: DictionnaryContext) => {
  return getDictionnaryByType('TEAM', context)
}